// app/javascript/pages/ChatPage.js
import React from "react";
import {
  useEffect,
  useRef,
  useCallback,
  useLayoutEffect,
  useState,
} from "react";
import { Box, useMediaQuery } from "@mui/material";
import ChatBox from "../components/ChatBox";
import { Navbar } from "../components/Navbar";
import Input from "../components/Input";
import {
  sendChatMessages,
  regenerateQuestionRecommendations,
  getThreadMessages,
  cancelChatMessages,
  bootstrapReturningUserThread,
  updateUserReview,
  markChatThreadRead,
} from "../api/message";
import {
  questionRegularText,
  requireLoginMessage,
  requireCreateAccountMessage,
  expiredSessionMessage,
  chatSartingQuestions,
} from "../utils/constants";
import { useTheme } from "@mui/material/styles";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import TermsModal from "../components/TermsModal";
import AddAppHomeModal from "../components/AddAppHomeModal";
import SignUpModalV2 from "../components/SignUpModalV2";
import PaywallModal from "../components/PaywallModal";
import PastDueModal from "../components/PastDueModal";
import AboutUserModal from "../components/AboutUserModal";
import { isMobileIOS, getDeviceType } from "../utils/user_agent";
import {
  connectWebSocket,
  connectUserThreadUpdates,
} from "../components/Chat/websocket";
import {
  firstUserMessage,
  askShareMessage,
  chatStartingResponse,
  startPlaceholderText,
  firstUserPlaceholderText,
} from "../utils/constants";
import { SubscriptionOfferCoupon } from "../components/SubscriptionCancellationModal";
import { useAppContext } from "../contexts/AppContext";
import { useChatContext } from "../contexts/ChatContext";
import Sidebar from "../components/Chat/Sidebar";
import { v4 as uuid } from "uuid";
import useSidebarOffset from "../hooks/useSidebarOffset";
import { isMobile } from "react-device-detect";
import DataOutput from "../components/Chat/DataOutput";
import { filesToAttachments } from "../utils/images_uploads_attachments";
import ProBanner from "../components/ProBanner";
import ReviewModal from "../components/ReviewModal";
import { reconcileFinalBotMessage } from "./chatMessageReconciliation";

const ChatPage = () => {
  const location = useLocation();
  const {
    appProps,
    messagesByThreadUuid,
    setMessagesByThreadUuid,
    showPastDueModal,
    setShowPastDueModal,
    setWatchlistData,
    websocketSubscriptionRef,
  } = useAppContext();

  const {
    loadingUserData,
    messageThreads,
    setMessageThreads,
    userData,
    setUserData,
    hasShownHistory,
    allowSetShit,
    setAllowSetShit,
    testVar,
    setTestVar,
    placeholderText,
    setResponseFlow,
    responseFlowByThreadUuid,
    setResponseFlowByThreadUuid,
    freshResponseFlow,
    setRegisterNavMessage,
    setHasAcceptedTerms,
    setShowChatShare,
    isNewUUID,
    showSignUpModal,
    setShowSignUpModal,
    showPaywallModal,
    setShowPaywallModal,
    paywallMessage,
    inputPlaceholderText,
    setInputPlaceholderText,
    showPaywallAfter,
    setShowPaywallAfter,
    loadingUserMessages,
  } = appProps;

  const {
    isSecondaryExperience,
    loadingResponse,
    showTermsModal,
    setShowTermsModal,
    showAddHomeModal,
    setShowAddHomeModal,
    aboutUserModal,
    setAboutUserModal,
    showSubOfferModal,
    setQuestion,
    preventQuestionInput,
    setPreventQuestionInput,
    preventQuestionInputByThreadUuid = {},
    showLoadingWaitingMessage,
    setShowLoadingWaitingMessage,
    useFullWidth,
    setIsSecondaryExperience,
    showSignInButtons,
    setQuestionOnDemand,
    question,
    setDeviceType,
    setSecondaryExperienceType,
    setSecondaryExperienceMessage,
    setExperienceMessageThreads,
    setUseFullWidth,
    secondaryExperienceMessage,
    setButtonOpacity,
    setPreventScroll,
    setLoadingResponse,
    deviceType,
    setFreeUnlimitedOnly,
    setHasShownFreeUnlimitedMessage,
    checkThing,
    setTestResponseMessage,
    setOpacity,
    setIdSelected,
    // setDataProcessesMessage,
    setLiveTextOutputting,

    showLoadingWaitingMessageByThreadUuid,
    setThreadShowLoadingWaitingMessage,
    setThreadLoadingPhaseMessage,
    setThreadLoadingPhaseDetail,
    pushDataProcessForThread,
    setThreadLiveTextOutputting,
    setThreadQuestionOnDemand,
    setThreadLoadingResponse,
    setThreadPreventQuestionInput,
    setThreadThing,
    setThreadTestResponseMessage,
    thingByThreadUuid,
    testResponseMessageByThreadUuid,
    loadingResponseByThreadUuid,
    moveThreadState,
    activeThread,
    setActiveThread,
    threads,
    setThreads,
    loadingMessages,
    setLoadingMessages,
    isSidebarOpen,
    setIsSidebarOpen,
    isDataProcessesOpen,
    setIsDataProcessesOpen,
    setShowSubOfferModal,
    setLatestTickerPrices,
    setDisplayUpdatedInfo,
    setAnimatedItems,
    websocketActiveTickerId,
    websocketActiveChartRef,
    loadingMessageThreads,
    scrollToMessageId,
    markThreadUnread,
    markThreadRead,
  } = useChatContext();

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const { slug: marketingSlug } = useParams();

  const navRef = useRef(null);
  const chatContainerRef = useRef();
  const chatMessagesContainerRef = useRef();
  const chatRef = useRef(null);
  const processedSlugRef = useRef(null);
  const lastReadBotIdRef = useRef({});
  const lastReadAtRef = useRef({});
  const [anchorOffsetTop, setAnchorOffsetTop] = useState(0);
  const [editingMessage, setEditingMessage] = useState(null);
  const [uneditedMessageThreads, setUneditedMessageThreads] = useState(null);
  const [cancelRequested, setCancelRequested] = useState(false);
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [rating, setRating] = useState(0);
  const [isGoogleReview, setIsGoogleReview] = useState(false);
  const inFlightSendByThreadRef = useRef({});

  const threadRequestKey = (threadUuid) => threadUuid || "__default__";

  const handleBeginEditMessage = useCallback(
    ({ idx, messageId, text }) => {
      setUneditedMessageThreads(messageThreads);
      setMessageThreads(messageThreads.slice(0, idx));
      messageThreadsOwnerRef.current = activeThread?.threadUuid ?? null;

      setEditingMessage({ idx, messageId });
      setQuestion(text || "");
    },
    [setQuestion, messageThreads, activeThread?.threadUuid],
  );

  const handleCancelEdit = useCallback(() => {
    setEditingMessage(null);
    if (uneditedMessageThreads) {
      setMessageThreads(uneditedMessageThreads);
      messageThreadsOwnerRef.current = activeThread?.threadUuid ?? null;
      setUneditedMessageThreads(null);
    }
  }, [uneditedMessageThreads, setMessageThreads, activeThread?.threadUuid]);

  const handleInputSubmit = (
    q = null,
    messageId = null,
    ticker_ids = null,
    imagesMeta = [],
  ) => {
    if (editingMessage) {
      return submitEditedMessage(q ?? "", imagesMeta);
    }
    return sendUserQuestion(q, messageId, ticker_ids, imagesMeta);
  };

  const submitEditedMessage = (newText, imagesMeta = []) => {
    const ctx = editingMessage;
    if (!ctx) {
      return sendUserQuestion(newText, null, null, imagesMeta);
    }

    let messageId;
    let orig = [];
    if (messageThreads.length > 0) {
      orig = messageThreads[messageThreads.length - 1];
      messageId = orig.id;
    } else {
      messageId = 0;
    }

    const cleaned = (newText ?? "").trim();
    if (!cleaned) {
      setEditingMessage(null);
      return;
    }

    const updated = {
      ...orig,
      message: cleaned,
      attachments: filesToAttachments(imagesMeta),
      edited: true,
      updatedAt: new Date(),
    };

    setEditingMessage(null);

    // Now re-run pipeline, but don't append another user bubble
    sendUserQuestion(cleaned, messageId, null, imagesMeta, {
      suppressLocalUserAppend: true,
      overrideMessage: updated,
      editedMessageId: messageId,
    });
  };

  const handleAbortResponse = async () => {
    if (!loadingResponse) return;

    setCancelRequested(true);

    // Tell backend to stop
    const threadUuid = activeThread?.threadUuid;
    if (threadUuid) {
      cancelChatMessages(threadUuid);
    }

    const key = threadRequestKey(threadUuid);
    const pendingRequest = inFlightSendByThreadRef.current?.[key];
    if (pendingRequest?.controller) {
      try {
        pendingRequest.controller.abort();
      } catch {}
    }
    if (inFlightSendByThreadRef.current?.[key]) {
      delete inFlightSendByThreadRef.current[key];
    }

    // Locally stop the “loading” behavior immediately
    if (threadUuid) {
      setThreadLoadingResponse(threadUuid, false);
      setThreadShowLoadingWaitingMessage(threadUuid, 0);
      setThreadLiveTextOutputting(threadUuid, false);
      setThreadLoadingPhaseMessage(threadUuid, null);
      setThreadLoadingPhaseDetail(threadUuid, null);
      setThreadPreventQuestionInput(threadUuid, false);
    } else {
      setLoadingResponse(false);
      setShowLoadingWaitingMessage(0);
      setLiveTextOutputting(false);
      setPreventQuestionInput(false);
    }
  };

  // Measure our nav bar for pinning user messages under it
  useLayoutEffect(() => {
    if (!navRef.current) return;

    const measure = () => {
      const rect = navRef.current.getBoundingClientRect();
      setAnchorOffsetTop((rect && rect.height ? rect.height : 0) + 8); // +8px breathing room
    };

    measure();

    let ro;
    if (typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(measure);
      ro.observe(navRef.current);
    }

    // in case styles/fonts settle after first paint
    const t1 = setTimeout(measure, 0);
    const t2 = setTimeout(measure, 200);
    window.addEventListener("resize", measure);

    return () => {
      if (ro) ro.disconnect();
      clearTimeout(t1);
      clearTimeout(t2);
      window.removeEventListener("resize", measure);
    };
  }, []);

  const sidebarOffset = useSidebarOffset(isSidebarOpen, isDataProcessesOpen);

  const lastSessionIdRef = useRef(null);
  const activeThreadRef = useRef(null);
  const messagesByThreadUuidRef = useRef(messagesByThreadUuid || {});
  const loadedMessagesByThreadUuidRef = useRef({});
  const responseFlowByThreadUuidRef = useRef(responseFlowByThreadUuid || {});
  const threadSubscriptionsRef = useRef(new Map());
  const messageThreadsOwnerRef = useRef(null);
  const resolvedTempThreadMapRef = useRef({});
  const threadSelectionTokenRef = useRef(0);
  const shouldForceFreshLoadThreadRef = useRef(false);
  const hasForcedFreshLoadThreadRef = useRef(false);
  const returningBootstrapAttemptedRef = useRef(false);
  const returningBootstrapInFlightRef = useRef(false);
  const primarySocketMetaRef = useRef({
    threadUuid: null,
    tickerId: null,
    sessionId: null,
  });

  useEffect(() => {
    returningBootstrapAttemptedRef.current = false;
    returningBootstrapInFlightRef.current = false;
  }, [userData?.user_id]);

  useEffect(() => {
    messagesByThreadUuidRef.current = messagesByThreadUuid || {};
  }, [messagesByThreadUuid]);

  useEffect(() => {
    responseFlowByThreadUuidRef.current = responseFlowByThreadUuid || {};
  }, [responseFlowByThreadUuid]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (window.__chatFreshLoadThreadInitialized) return;
    window.__chatFreshLoadThreadInitialized = true;
    shouldForceFreshLoadThreadRef.current = true;
  }, []);

  const updateThreadMessages = useCallback(
    (threadUuid, updater) => {
      if (!threadUuid) return;
      const currentMap = messagesByThreadUuidRef.current || {};
      const current = Array.isArray(currentMap?.[threadUuid])
        ? currentMap[threadUuid]
        : [];
      const next = typeof updater === "function" ? updater(current) : updater;
      const nextMap = { ...(currentMap || {}), [threadUuid]: next };
      messagesByThreadUuidRef.current = nextMap;
      setMessagesByThreadUuid(nextMap);
      if (activeThreadRef.current?.threadUuid === threadUuid) {
        messageThreadsOwnerRef.current = threadUuid;
        setMessageThreads(next);
      }
    },
    [setMessagesByThreadUuid, setMessageThreads],
  );

  const appendMessage = (threadUuid, msg) => {
    if (!threadUuid) return;
    updateThreadMessages(threadUuid, (prev) => [...prev, msg]);
  };

  const setResponseFlowForThread = useCallback(
    (threadUuid, updater) => {
      if (!threadUuid) return;
      const currentMap = responseFlowByThreadUuidRef.current || {};
      const current = currentMap?.[threadUuid] || freshResponseFlow();
      const next = typeof updater === "function" ? updater(current) : updater;
      const nextMap = { ...(currentMap || {}), [threadUuid]: next };
      responseFlowByThreadUuidRef.current = nextMap;
      setResponseFlowByThreadUuid(nextMap);
      if (activeThreadRef.current?.threadUuid === threadUuid) {
        setResponseFlow(next);
      }
    },
    [setResponseFlowByThreadUuid, setResponseFlow, freshResponseFlow],
  );

  const ensureResponseFlowForThread = useCallback(
    (threadUuid) => {
      if (!threadUuid) return null;
      const existing = responseFlowByThreadUuidRef.current?.[threadUuid];
      if (existing) return existing;
      const fresh = freshResponseFlow();
      const currentMap = responseFlowByThreadUuidRef.current || {};
      const nextMap = { ...(currentMap || {}), [threadUuid]: fresh };
      responseFlowByThreadUuidRef.current = nextMap;
      setResponseFlowByThreadUuid(nextMap);
      return fresh;
    },
    [setResponseFlowByThreadUuid, freshResponseFlow],
  );

  const moveMessagesByThreadUuid = useCallback(
    (fromThreadUuid, toThreadUuid) => {
      if (!fromThreadUuid || !toThreadUuid || fromThreadUuid === toThreadUuid)
        return;
      const currentMap = messagesByThreadUuidRef.current || {};
      if (!Object.prototype.hasOwnProperty.call(currentMap, fromThreadUuid))
        return;
      const next = { ...(currentMap || {}) };
      next[toThreadUuid] = next[fromThreadUuid];
      delete next[fromThreadUuid];
      messagesByThreadUuidRef.current = next;
      setMessagesByThreadUuid(next);
    },
    [setMessagesByThreadUuid],
  );

  const moveResponseFlowByThreadUuid = useCallback(
    (fromThreadUuid, toThreadUuid) => {
      if (!fromThreadUuid || !toThreadUuid || fromThreadUuid === toThreadUuid)
        return;
      const currentMap = responseFlowByThreadUuidRef.current || {};
      if (!Object.prototype.hasOwnProperty.call(currentMap, fromThreadUuid))
        return;
      const next = { ...(currentMap || {}) };
      next[toThreadUuid] = next[fromThreadUuid];
      delete next[fromThreadUuid];
      responseFlowByThreadUuidRef.current = next;
      setResponseFlowByThreadUuid(next);
    },
    [setResponseFlowByThreadUuid],
  );

  const buildWebsocketHandlers = useCallback(
    (threadUuid, isPrimary) => {
      const noop = () => {};
      return {
        setQuestionOnDemand: (val) =>
          setThreadQuestionOnDemand(threadUuid, val),
        setMessageThreads: (updater) =>
          updateThreadMessages(threadUuid, updater),
        showLoadingWaitingMessage:
          showLoadingWaitingMessageByThreadUuid?.[threadUuid] ?? null,
        setShowLoadingWaitingMessage: (val) =>
          setThreadShowLoadingWaitingMessage(threadUuid, val),
        setLoadingPhaseMessage: (val) =>
          setThreadLoadingPhaseMessage(threadUuid, val),
        setLoadingPhaseDetail: (val) =>
          setThreadLoadingPhaseDetail(threadUuid, val),
        pushDataProcess: (payload) =>
          pushDataProcessForThread(threadUuid, payload),
        setLiveTextOutputting: (val) =>
          setThreadLiveTextOutputting(threadUuid, val),
        setLatestTickerPrices: isPrimary ? setLatestTickerPrices : noop,
        setDisplayUpdatedInfo: isPrimary ? setDisplayUpdatedInfo : noop,
        setWatchlistData: isPrimary ? setWatchlistData : noop,
        setAnimatedItems: isPrimary ? setAnimatedItems : noop,
      };
    },
    [
      updateThreadMessages,
      showLoadingWaitingMessageByThreadUuid,
      setThreadShowLoadingWaitingMessage,
      setThreadLoadingPhaseMessage,
      setThreadLoadingPhaseDetail,
      pushDataProcessForThread,
      setThreadLiveTextOutputting,
      setThreadQuestionOnDemand,
      setLatestTickerPrices,
      setDisplayUpdatedInfo,
      setWatchlistData,
      setAnimatedItems,
    ],
  );

  const ensureThreadSubscription = useCallback(
    (threadUuid, options = {}) => {
      if (!threadUuid) return null;
      const sessionId = userData?.current_session_id;
      if (!sessionId) return null;
      const { force = false, setAsPrimary = null } = options || {};
      const subs = threadSubscriptionsRef.current;
      const existing = subs.get(threadUuid);
      if (existing && force) {
        try {
          existing.cleanup?.();
        } catch {}
        subs.delete(threadUuid);
      }

      const isPrimary =
        typeof setAsPrimary === "boolean"
          ? setAsPrimary
          : activeThreadRef.current?.threadUuid === threadUuid;
      const handlers = buildWebsocketHandlers(threadUuid, isPrimary);

      const entry = connectWebSocket(
        handlers.setQuestionOnDemand,
        sessionId,
        websocketSubscriptionRef,
        handlers.setMessageThreads,
        handlers.showLoadingWaitingMessage,
        handlers.setShowLoadingWaitingMessage,
        useFullWidth,
        setUseFullWidth,
        handlers.setLoadingPhaseMessage,
        handlers.setLoadingPhaseDetail,
        handlers.pushDataProcess,
        handlers.setLiveTextOutputting,
        handlers.setLatestTickerPrices,
        handlers.setDisplayUpdatedInfo,
        handlers.setWatchlistData,
        handlers.setAnimatedItems,
        { threadUuid },
        websocketActiveChartRef,
        { setAsPrimary: isPrimary },
      );

      subs.set(threadUuid, entry);
      return entry;
    },
    [
      userData?.current_session_id,
      websocketSubscriptionRef,
      buildWebsocketHandlers,
      useFullWidth,
      setUseFullWidth,
      websocketActiveChartRef,
    ],
  );

  useEffect(() => {
    setIsSidebarOpen(isDesktop ? true : false);
    setIsDataProcessesOpen(isDesktop ? true : false);
  }, [isDesktop]);

  useEffect(() => {
    const curId = 2;

    if (!curId || loadingUserData) {
      return;
    }

    if (lastSessionIdRef.current === null) {
      lastSessionIdRef.current = curId;
      return;
    }

    if (curId !== lastSessionIdRef.current) {
      handleAddThread();
      lastSessionIdRef.current = curId;
    }
  }, [userData?.current_session_id, loadingUserData]);

  useEffect(() => {
    const threadId = activeThread?.threadUuid;
    const sessionId = userData?.current_session_id;
    if (!threadId || !sessionId) return;
    const meta = primarySocketMetaRef.current || {};
    const shouldForce =
      meta.threadUuid !== threadId || meta.sessionId !== sessionId;
    const entry = ensureThreadSubscription(threadId, {
      force: shouldForce,
      setAsPrimary: true,
    });
    if (entry?.subscription) {
      websocketSubscriptionRef.current = entry.subscription;
    }
    primarySocketMetaRef.current = {
      threadUuid: threadId,
      tickerId: websocketActiveTickerId,
      sessionId,
    };
  }, [
    userData?.current_session_id,
    activeThread?.threadUuid,
    websocketActiveTickerId,
    ensureThreadSubscription,
    websocketSubscriptionRef,
  ]);

  useEffect(() => {
    return () => {
      const subs = threadSubscriptionsRef.current;
      subs.forEach((entry) => {
        try {
          entry.cleanup?.();
        } catch {}
      });
      subs.clear();
    };
  }, []);

  useEffect(() => {
    const subs = threadSubscriptionsRef.current;
    if (!subs?.size) return;
    const activeId = activeThread?.threadUuid ?? null;
    subs.forEach((entry, threadUuid) => {
      if (threadUuid === activeId) return;
      if (loadingResponseByThreadUuid?.[threadUuid]) return;
      try {
        entry.cleanup?.();
      } catch {}
      subs.delete(threadUuid);
    });
  }, [loadingResponseByThreadUuid, activeThread?.threadUuid]);

  useEffect(() => {
    activeThreadRef.current = activeThread;
  }, [activeThread]);

  useEffect(() => {
    const threadUuid = activeThread?.threadUuid ?? null;
    if (!threadUuid) return;
    const existing = responseFlowByThreadUuidRef.current?.[threadUuid];
    const flow = existing || ensureResponseFlowForThread(threadUuid);
    if (flow) setResponseFlow(flow);
  }, [activeThread?.threadUuid, ensureResponseFlowForThread, setResponseFlow]);

  const markThreadReadNow = useCallback(
    (threadUuid, options = {}) => {
      if (!threadUuid || threadUuid.startsWith("temp-")) return;
      const { botMessageId = null } = options || {};
      const now = Date.now();
      lastReadAtRef.current = {
        ...(lastReadAtRef.current || {}),
        [threadUuid]: Math.max(
          Number(lastReadAtRef.current?.[threadUuid]) || 0,
          now,
        ),
      };
      if (botMessageId != null) {
        const nextId = Number(botMessageId);
        if (Number.isFinite(nextId)) {
          lastReadBotIdRef.current = {
            ...(lastReadBotIdRef.current || {}),
            [threadUuid]: Math.max(
              Number(lastReadBotIdRef.current?.[threadUuid]) || 0,
              nextId,
            ),
          };
        }
      }
      markThreadRead(threadUuid);
      markChatThreadRead(threadUuid)
        .then((res) => {
          const serverMs = Date.parse(res?.lastReadAt || "");
          if (!Number.isFinite(serverMs)) return;
          lastReadAtRef.current = {
            ...(lastReadAtRef.current || {}),
            [threadUuid]: Math.max(
              Number(lastReadAtRef.current?.[threadUuid]) || 0,
              serverMs,
            ),
          };
        })
        .catch(() => {});
    },
    [markThreadRead, markChatThreadRead],
  );

  useEffect(() => {
    const threadUuid = activeThread?.threadUuid;
    if (!threadUuid || threadUuid.startsWith("temp-")) return;
    markThreadReadNow(threadUuid);
  }, [activeThread?.threadUuid, markThreadReadNow]);

  useEffect(() => {
    const threadUuid = activeThread?.threadUuid;
    if (!threadUuid || threadUuid.startsWith("temp-")) return;
    if (!messageThreads || messageThreads.length === 0) return;
    const last = messageThreads[messageThreads.length - 1];
    if (!last || last.sender !== "bot") return;
    if (!last.id) return;
    const seenId = Number(lastReadBotIdRef.current?.[threadUuid]);
    const nextId = Number(last.id);
    if (Number.isFinite(seenId) && Number.isFinite(nextId) && seenId >= nextId)
      return;
    markThreadReadNow(threadUuid, { botMessageId: last.id });
  }, [activeThread?.threadUuid, messageThreads, markThreadReadNow]);

  useEffect(() => {
    if (loadingUserData) return;
    // Subscribe based on either uuid (pre-account) or user_id (logged-in)
    if (!userData?.uuid && !userData?.user_id) return;
    const cleanup = connectUserThreadUpdates({
      setThreads,
      setMessageThreads,
      activeThreadRef,
      setActiveThread,
      markThreadUnread,
      markThreadRead,
      getLastReadAt: (uuid) => lastReadAtRef.current?.[uuid],
      getLastReadBotId: (uuid) => lastReadBotIdRef.current?.[uuid],
    });
    return cleanup;
  }, [
    loadingUserData,
    userData?.uuid,
    userData?.user_id,
    markThreadUnread,
    markThreadRead,
  ]);

  useEffect(() => {
    const d = getDeviceType();
    setDeviceType(d);
  }, []);

  const handleWindowScroll = useCallback((e) => {
    setTestVar(window.pageYOffset);
  }, []);
  useEffect(() => {
    window.addEventListener("scroll", handleWindowScroll, true);
  }, [handleWindowScroll]);

  const navigate = useNavigate();

  const isLoggedIn = !!userData.user_id;

  const onFocus = (e) => {
    if (!isLoggedIn) {
      // appProps.setRegisterNavMessage(requireLoginMessage)
      // navigate('/register')
    } else {
      setTimeout(function () {
        setAllowSetShit(true);
      }, 150); //magic number is 150
    }
  };

  useEffect(() => {
    if (!marketingSlug) return;
    if (processedSlugRef.current === marketingSlug) return;

    // mirror your existing gating to avoid running too early
    const ready =
      !loadingUserData &&
      Object.keys(userData || {}).length > 0 &&
      !loadingUserMessages &&
      !loadingMessages &&
      (activeThread || userData.uuidHasAccount == false);

    if (!ready) return;

    let aborted = false;

    (async () => {
      try {
        const res = await fetch("/graphql", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            query: `{ marketingLink(slug: "${marketingSlug}") { query slug } }`,
          }),
        });
        const json = await res.json();
        const link = json?.data?.marketingLink;
        const q = link?.query;
        if (!q || aborted) return;

        // Avoid auto-sending duplicates (same as your querystring guard)
        let shouldAsk = true;
        if (messageThreads.length > 1) {
          const lastQs = messageThreads.filter((m) => m.sender === "human");
          if (lastQs.length > 0) {
            const lastQ = lastQs[lastQs.length - 1];
            const oneHourAgo = new Date(Date.now() - 60 * 60 * 1000);
            if (lastQ.message === q && new Date(lastQ.createdAt) > oneHourAgo) {
              shouldAsk = false;
            }
          }
        }

        if (shouldAsk) {
          handleInputSubmit(q);
          // Optional: move user to /chat after firing
          // navigate('/chat', { replace: true });
        }
      } catch (e) {
        console.error("marketing slug fetch failed", e);
      } finally {
        processedSlugRef.current = marketingSlug;
        navigate("/chat", { replace: true }); // remove slug from URL so it can’t trigger again
      }
    })();

    return () => {
      aborted = true;
    };
  }, [
    marketingSlug,
    loadingUserData,
    loadingUserMessages,
    loadingMessages,
    userData,
    messageThreads,
    activeThread,
  ]);

  const selectActiveThread = async (t, scrollMessageId = null) => {
    if (!t) return; // may be null if thread was empty

    const selectionToken = threadSelectionTokenRef.current + 1;
    threadSelectionTokenRef.current = selectionToken;
    const selectedThreadUuid = t?.threadUuid ?? null;
    const isStillSelectedThread = () =>
      threadSelectionTokenRef.current === selectionToken &&
      (activeThreadRef.current?.threadUuid ?? null) === selectedThreadUuid;

    setActiveThread(t);
    activeThreadRef.current = t;

    // only because we don't want the custom answer to carry over to the thread
    // later we'll save the follow up questions to show
    if (t?.threadUuid) {
      const flow = ensureResponseFlowForThread(t.threadUuid);
      if (flow) setResponseFlow(flow);
    } else {
      setResponseFlow(freshResponseFlow());
    }

    const cachedMessagesByThreadUuid = messagesByThreadUuidRef.current || {};
    if (t?.threadUuid?.startsWith("temp-")) {
      // Temp threads can stream independently; restore any cached messages for this temp uuid.
      const cachedTempMessages = cachedMessagesByThreadUuid?.[t.threadUuid];
      messageThreadsOwnerRef.current = t.threadUuid;
      setMessageThreads(
        Array.isArray(cachedTempMessages) ? cachedTempMessages : [],
      );
      setLoadingMessages(false);
      return;
    }

    // Only trust cache if the thread is known-loaded, or if we already have concrete messages.
    // This prevents a refresh race from caching a temporary empty list for a thread whose fetch was canceled.
    const cachedThreadMessages = cachedMessagesByThreadUuid?.[t.threadUuid];
    const hasCachedThreadMessages = Object.prototype.hasOwnProperty.call(
      cachedMessagesByThreadUuid,
      t.threadUuid,
    );
    const shouldUseCachedThreadMessages =
      hasCachedThreadMessages &&
      (Boolean(loadedMessagesByThreadUuidRef.current?.[t.threadUuid]) ||
        (Array.isArray(cachedThreadMessages) &&
          cachedThreadMessages.length > 0));

    if (shouldUseCachedThreadMessages) {
      messageThreadsOwnerRef.current = t.threadUuid;
      setMessageThreads(
        Array.isArray(cachedThreadMessages) ? cachedThreadMessages : [],
      );
      return;
    }

    try {
      setLoadingMessages(true);
      messageThreadsOwnerRef.current = t.threadUuid;
      setMessageThreads([]); // maybe try setting as empty until the messages come through?
      const targetMessageId = scrollMessageId || scrollToMessageId || null;
      const msgs = await getThreadMessages({
        threadUuid: t.threadUuid,
        messageId: targetMessageId,
      });
      if (!isStillSelectedThread()) return;
      loadedMessagesByThreadUuidRef.current = {
        ...(loadedMessagesByThreadUuidRef.current || {}),
        [t.threadUuid]: true,
      };
      messageThreadsOwnerRef.current = t.threadUuid;
      setMessageThreads(msgs);
      // messagesByThreadUuid[t.threadUuid] = msgs
    } catch (error) {
      console.log("Error fetching thread messages", error);
    } finally {
      if (isStillSelectedThread()) {
        setLoadingMessages(false);
      }
    }
  };

  useEffect(() => {
    if (returningBootstrapAttemptedRef.current) return;
    if (returningBootstrapInFlightRef.current) return;
    if (loadingUserData || loadingMessageThreads) return;
    if (!userData?.user_id) return;

    returningBootstrapInFlightRef.current = true;
    (async () => {
      const resp = await bootstrapReturningUserThread();
      if (!resp?.triggered || !resp?.threadUuid) return;

      const proactiveThread = {
        threadUuid: resp.threadUuid,
        title: resp.threadTitle || "Quick Follow-Up",
        isAdminTargeted: false,
      };

      setThreads((prev) => {
        const safePrev = Array.isArray(prev) ? prev : [];
        return [
          proactiveThread,
          ...safePrev.filter(
            (thread) => thread?.threadUuid !== proactiveThread.threadUuid,
          ),
        ];
      });

      selectActiveThread(proactiveThread);
    })().finally(() => {
      returningBootstrapAttemptedRef.current = true;
      returningBootstrapInFlightRef.current = false;
    });
  }, [
    loadingUserData,
    loadingMessageThreads,
    userData?.user_id,
    setThreads,
    selectActiveThread,
  ]);

  // also add a dependency to message threads..
  // so that any time the message threads is updated, we update the larger
  // messagesByThreadUuid...
  useEffect(() => {
    const threadUuid = activeThread?.threadUuid;
    if (!threadUuid) return;
    if (
      messageThreadsOwnerRef.current &&
      messageThreadsOwnerRef.current !== threadUuid
    ) {
      return;
    }
    const currentMap = messagesByThreadUuidRef.current || {};
    const nextMap = {
      ...(currentMap || {}),
      [threadUuid]: messageThreads || [],
    };
    messagesByThreadUuidRef.current = nextMap;
    setMessagesByThreadUuid(nextMap);
  }, [messageThreads, activeThread?.threadUuid, setMessagesByThreadUuid]);

  useEffect(() => {
    const hasAutoQuestionParam = Boolean(
      new URLSearchParams(location.search).get("question")?.trim(),
    );

    if (loadingUserData) {
      setIsSecondaryExperience(null);
    } else {
      if (
        !hasAutoQuestionParam &&
        !isLoggedIn &&
        messageThreads.length <= 1 &&
        !(messageThreads[0] && messageThreads[0].sender == "human")
      ) {
        setIsSecondaryExperience(true);
        setSecondaryExperienceType("new-user");
        setSecondaryExperienceMessage(firstUserMessage);
      } else if (userData.showAskShareMessage) {
        // replace with condition for ask-share!
        setIsSecondaryExperience(true);
        setSecondaryExperienceType("ask-share");
        setSecondaryExperienceMessage(askShareMessage);
      } else {
        setSecondaryExperienceType(null);
        setIsSecondaryExperience(false);
        setInputPlaceholderText(startPlaceholderText);
      }
    }
  }, [loadingUserData, userData, messageThreads, location.search]);

  useEffect(() => {
    if (isSecondaryExperience != null) {
      if (isSecondaryExperience) {
        setExperienceMessageThreads([{ sender: "bot", message: "" }]);
        setTimeout(() => {
          const characters = secondaryExperienceMessage.split("");
          let curStr = "";
          characters.forEach((char, index) => {
            setTimeout(() => {
              curStr = curStr.concat(char);
              setExperienceMessageThreads([
                {
                  sender: "bot",
                  message: curStr,
                },
              ]);
            }, index * 20); //30  // THIS is how quickly the letters print out
          });
        }, 500);

        setTimeout(() => {
          const characters = firstUserPlaceholderText.split("");
          let curStr = "";
          characters.forEach((char, index) => {
            setTimeout(() => {
              curStr = curStr.concat(char);
              setInputPlaceholderText(curStr);
            }, index * 33); //50  // THIS is how quickly the letters print out
          });
        }, 3100); //4600)
      } else if (messageThreads.length == 1) {
        // setMessageThreads([chatStartingResponse]);
        // setInputPlaceholderText(placeholderText);
      }
    }
  }, [isSecondaryExperience]);

  useEffect(() => {
    if (navRef.current && allowSetShit) {
      navRef.current.style.top = `${testVar}px`;
      // Only if there are messages making up less than 50% of the scroll area to fill do we want to move them down; otherwise the keyboard
      // comes up and the messages move up naturally (not behind header).
      // if (chatMessagesContainerRef.current.scrollHeight < .5*chatContainerRef.current.scrollHeight) {
      if (
        messageThreads.length < 2 &&
        testVar &&
        chatRef.current &&
        chatRef.current.style
      ) {
        chatRef.current.style.top = `${testVar - 100}px`;
      }
      setTimeout(function () {
        setAllowSetShit(false);
      }, 150);
    }
  }, [allowSetShit, testVar]);

  const onBlur = (e) => {
    setTimeout(function () {
      if (navRef.current && chatRef.current && chatRef.current.style) {
        navRef.current.style.top = "0px";
        chatRef.current.style.top = `0px`;
      }
      setAllowSetShit(false);
    }, 150);
  };

  const regenButtonRecommendations = async (question = null) => {
    const threadUuid = activeThread?.threadUuid ?? null;
    const responseRecommendations = await regenerateQuestionRecommendations(
      userData,
      appProps,
      question,
    );
    const questions_prepopulated = responseRecommendations.messages;
    const questions_prepopulated_tickers = responseRecommendations.tickers;
    let obj = [];
    let tickers;
    questions_prepopulated.forEach((message_text, idx) => {
      tickers =
        questions_prepopulated_tickers[idx] == ""
          ? ""
          : JSON.parse(questions_prepopulated_tickers[idx]);
      let q = {
        sender: "human",
        isButton: true,
        message: message_text,
        tickers: tickers,
      };
      if (idx == 0) {
        if (threadUuid) {
          setResponseFlowForThread(threadUuid, (responseFlow) => ({
            ...responseFlow,
            question1: [true, q.message, q.tickers, false, ""],
          }));
        } else {
          setResponseFlow((responseFlow) => ({
            ...responseFlow,
            question1: [true, q.message, q.tickers, false, ""],
          }));
        }
      } else {
        if (threadUuid) {
          setResponseFlowForThread(threadUuid, (responseFlow) => ({
            ...responseFlow,
            question2: [
              true,
              q.message,
              q.tickers,
              responseRecommendations.isAdvanced,
              responseRecommendations.advancedType,
            ],
          }));
        } else {
          setResponseFlow((responseFlow) => ({
            ...responseFlow,
            question2: [
              true,
              q.message,
              q.tickers,
              responseRecommendations.isAdvanced,
              responseRecommendations.advancedType,
            ],
          }));
        }
      }
      obj.push([true, message_text, tickers]);
    });
    return obj;
  };

  useEffect(() => {
    const pending = thingByThreadUuid || {};
    const responses = testResponseMessageByThreadUuid || {};
    Object.keys(pending).forEach((threadUuid) => {
      if (!pending[threadUuid]) return;
      const responseMessage = responses[threadUuid];
      if (!responseMessage) return;
      updateThreadMessages(threadUuid, (prev) => {
        const last = prev[prev.length - 1];
        if (last && last.sender === "bot") {
          const finalMsg = reconcileFinalBotMessage(last, responseMessage);
          return [...prev.slice(0, -1), finalMsg];
        }
        return [...prev, responseMessage];
      });
      const isActiveThread = activeThreadRef.current?.threadUuid === threadUuid;
      if (!isActiveThread) {
        markThreadUnread(threadUuid);
      }
      setThreadThing(threadUuid, false);
      setThreadTestResponseMessage(threadUuid, "");
    });
  }, [
    thingByThreadUuid,
    testResponseMessageByThreadUuid,
    updateThreadMessages,
    markThreadUnread,
    setThreadThing,
    setThreadTestResponseMessage,
  ]);

  // This code was buggy.. sometimes
  // Sometimes "newActiveThread" is undefined because it's in the prev mapwhere it is setasync
  // const resolveTempId = useCallback(
  //   (tempUuid, realUuid, title) => {
  //     let newActiveThread;
  //     setThreads((prev) =>
  //       prev.map((t) => {
  //         // console.log("What do we have... ?", t.threadUuid, tempUuid)
  //         if (t.threadUuid === tempUuid) {
  //           newActiveThread = { ...t, threadUuid: realUuid, title };
  //           return newActiveThread;
  //         } else {
  //           return t;
  //         }
  //       })
  //     );
  //     // needs to set the activeThread as well.
  //     if (newActiveThread) {
  //       setActiveThread(newActiveThread);
  //     }
  //   },
  //   [setThreads]
  // );

  // This is the correct way to do the function:
  const resolveTempId = useCallback(
    (tempUuid, realUuid, title) => {
      setThreads((prev) =>
        prev.map((t) =>
          t.threadUuid === tempUuid ? { ...t, threadUuid: realUuid, title } : t,
        ),
      );
      setActiveThread((prev) =>
        prev && prev.threadUuid === tempUuid
          ? { ...prev, threadUuid: realUuid, title }
          : prev,
      );
      if (tempUuid && realUuid && tempUuid !== realUuid) {
        if (
          Object.prototype.hasOwnProperty.call(
            loadedMessagesByThreadUuidRef.current || {},
            tempUuid,
          )
        ) {
          loadedMessagesByThreadUuidRef.current = {
            ...(loadedMessagesByThreadUuidRef.current || {}),
            [realUuid]: loadedMessagesByThreadUuidRef.current[tempUuid],
          };
          delete loadedMessagesByThreadUuidRef.current[tempUuid];
        }
        resolvedTempThreadMapRef.current = {
          ...(resolvedTempThreadMapRef.current || {}),
          [tempUuid]: realUuid,
        };
        if (activeThreadRef.current?.threadUuid === tempUuid) {
          activeThreadRef.current = {
            ...(activeThreadRef.current || {}),
            threadUuid: realUuid,
            title,
          };
        }
        moveThreadState(tempUuid, realUuid);
        moveMessagesByThreadUuid(tempUuid, realUuid);
        moveResponseFlowByThreadUuid(tempUuid, realUuid);
        if (messageThreadsOwnerRef.current === tempUuid) {
          messageThreadsOwnerRef.current = realUuid;
        }
        const subs = threadSubscriptionsRef.current;
        const existing = subs.get(tempUuid);
        if (existing) {
          try {
            existing.cleanup?.();
          } catch {}
          subs.delete(tempUuid);
        }
        const shouldBePrimary =
          activeThreadRef.current?.threadUuid === realUuid ||
          activeThreadRef.current?.threadUuid === tempUuid ||
          activeThread?.threadUuid === realUuid ||
          activeThread?.threadUuid === tempUuid;
        const entry = ensureThreadSubscription(realUuid, {
          force: true,
          setAsPrimary: shouldBePrimary,
        });
        if (shouldBePrimary && entry?.subscription) {
          websocketSubscriptionRef.current = entry.subscription;
          primarySocketMetaRef.current = {
            ...(primarySocketMetaRef.current || {}),
            threadUuid: realUuid,
            sessionId:
              userData?.current_session_id ||
              primarySocketMetaRef.current?.sessionId ||
              null,
          };
        }
      }
    },
    [
      setThreads,
      setActiveThread,
      activeThread?.threadUuid,
      moveThreadState,
      moveMessagesByThreadUuid,
      moveResponseFlowByThreadUuid,
      ensureThreadSubscription,
      websocketSubscriptionRef,
      userData?.current_session_id,
    ],
  );

  const sendUserQuestion = (
    q = null,
    messageId = null,
    ticker_ids = null,
    imagesMeta = [],
    options = {},
  ) => {
    setIsSecondaryExperience(false);
    let threadUuid =
      activeThreadRef.current?.threadUuid ?? activeThread?.threadUuid ?? null;
    const requestedThreadUuid = threadUuid;
    if (requestedThreadUuid?.startsWith("temp-")) {
      const mappedRealUuid =
        resolvedTempThreadMapRef.current?.[requestedThreadUuid];
      if (mappedRealUuid) {
        threadUuid = mappedRealUuid;
        if (resolvedTempThreadMapRef.current?.[requestedThreadUuid]) {
          delete resolvedTempThreadMapRef.current[requestedThreadUuid];
        }
      }
    }
    if (threadUuid) {
      ensureThreadSubscription(threadUuid, {
        setAsPrimary: true,
      });
    }
    const { editedMessageId = null, tradeProposalId = null } = options || {};
    let isExplainWhy = q == "Explain why?";

    // If they have asked too many questions; need to require sign up/sign in
    if (userData.requireSignIn) {
      if (userData.uuidHasAccount) {
        appProps.setRegisterNavMessage(requireLoginMessage);
      } else {
        appProps.setRegisterNavMessage(requireCreateAccountMessage);
      }
      navigate("/register");
      return;
    }

    // If user is logged in; check that they have a validated email
    if (isLoggedIn && userData.is_email_confirmed == false) {
      navigate("/confirm-email");
      return;
    }

    const isPrevented = threadUuid
      ? Boolean(preventQuestionInputByThreadUuid?.[threadUuid])
      : preventQuestionInput;
    if (isPrevented) {
      return;
    }
    if (threadUuid) {
      setThreadPreventQuestionInput(threadUuid, true);
    } else if (!preventQuestionInput) {
      setPreventQuestionInput(true);
    }
    let message;
    if (q) {
      setIdSelected(messageId);
      message = {
        id: Date.now(),
        sender: "human",
        message: q,
        createdAt: new Date(),
        shouldAnchor: true,
        attachments: filesToAttachments(imagesMeta),
      };
      setIdSelected(messageId);
    } else {
      message = {
        id: Date.now(),
        sender: "human",
        message: question,
        createdAt: new Date(),
        shouldAnchor: true,
        attachments: filesToAttachments(imagesMeta),
      };
    }

    // fire off facebook ask question tracking if not admin user
    if (
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "staging.inciteai.com" &&
      typeof window.fbq === "function" &&
      !userData.is_admin_user
    ) {
      window.fbq("trackCustom", "questionAsked");
    }

    if (threadUuid) {
      setResponseFlowForThread(threadUuid, (responseFlow) => ({
        ...responseFlow,
        review: false,
        line: false,
        text: false,
        question1: [false, responseFlow.question1[1]],
        question2: [false, responseFlow.question2[1]],
        regen: false,
      }));
    } else {
      setResponseFlow((responseFlow) => ({
        ...responseFlow,
        review: false,
        line: false,
        text: false,
        question1: [false, responseFlow.question1[1]],
        question2: [false, responseFlow.question2[1]],
        regen: false,
      }));
    }

    let hasReceivedResponse = false;
    setButtonOpacity(0.0);
    setPreventScroll(true);
    setCancelRequested(false);
    if (threadUuid) {
      appendMessage(threadUuid, message);
    } else {
      setMessageThreads((prev) => [...prev, message]);
    }
    if (!hasReceivedResponse) {
      setQuestion("");
      if (threadUuid) {
        setThreadLoadingResponse(threadUuid, true);
        setThreadShowLoadingWaitingMessage(threadUuid, 0);
        setThreadLoadingPhaseMessage(threadUuid, null);
        setThreadLoadingPhaseDetail(threadUuid, null);
        setThreadLiveTextOutputting(threadUuid, false);
        setThreadQuestionOnDemand(threadUuid, false);
      } else {
        setLoadingResponse(true);
      }
      setPreventScroll(false);
    }

    let send_message = message.message;
    send_message = send_message + questionRegularText;
    console.log("about to request...");
    const requestKey = threadRequestKey(threadUuid);
    const requestToken = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const priorRequest = inFlightSendByThreadRef.current?.[requestKey];
    if (priorRequest?.controller) {
      try {
        priorRequest.controller.abort();
      } catch {}
    }
    const requestController =
      typeof AbortController !== "undefined" ? new AbortController() : null;
    inFlightSendByThreadRef.current = {
      ...(inFlightSendByThreadRef.current || {}),
      [requestKey]: {
        requestToken,
        controller: requestController,
      },
    };
    let botResponse = sendChatMessages(
      send_message,
      isExplainWhy,
      ticker_ids,
      deviceType,
      "browser",
      threadUuid,
      resolveTempId,
      imagesMeta,
      editedMessageId,
      tradeProposalId,
      { signal: requestController?.signal },
    );

    botResponse
      .then((botResponse) => {
        console.log("so we are here?", botResponse);
        console.log("ids", {
          captured: threadUuid,
          resolved: botResponse?.threadUuid,
          active: activeThreadRef.current?.threadUuid,
        });

        const resolvedThreadUuid = botResponse?.threadUuid || threadUuid;
        hasReceivedResponse = true;
        let response_message;
        let questions_prepopulated;
        let questions_prepop_tickers;
        // If an error is returned
        if (botResponse && botResponse.error) {
          if (botResponse.error == "Session Expired") {
            setRegisterNavMessage(expiredSessionMessage);
            navigate("/register");
            if (resolvedThreadUuid) {
              updateThreadMessages(resolvedThreadUuid, (messageThreads) => [
                ...messageThreads.slice(0, -1),
              ]);
              setResponseFlowForThread(resolvedThreadUuid, (responseFlow) => ({
                ...responseFlow,
                question1: [true, message.message, null, false, null],
                question2: [
                  true,
                  chatSartingQuestions[1].message,
                  null,
                  botResponse.isAdvanced,
                  botResponse.advancedType,
                ],
                regen: true,
              }));
              setThreadLoadingResponse(resolvedThreadUuid, false);
              setThreadShowLoadingWaitingMessage(resolvedThreadUuid, 0);
              setThreadLoadingPhaseMessage(resolvedThreadUuid, null);
              setThreadLoadingPhaseDetail(resolvedThreadUuid, null);
              setThreadLiveTextOutputting(resolvedThreadUuid, false);
              setThreadPreventQuestionInput(resolvedThreadUuid, false);
            } else {
              setMessageThreads((messageThreads) => [
                ...messageThreads.slice(0, -1),
              ]);
              setResponseFlow((responseFlow) => ({
                ...responseFlow,
                question1: [true, message.message, null, false, null],
                question2: [
                  true,
                  chatSartingQuestions[1].message,
                  null,
                  botResponse.isAdvanced,
                  botResponse.advancedType,
                ],
                regen: true,
              }));
              setLoadingResponse(false);
              setShowLoadingWaitingMessage(0);
              setPreventQuestionInput(false);
            }
            return;
          }

          console.log("IN THE THEN!", botResponse);
          response_message = {
            createdAt: null,
            message: botResponse.error, // This could be the custom error message you want to show
            sender: "bot",
            tickerDescription: [],
            answeredTickerIds: [],
            logoUrls: [],
          };
          if (botResponse.show_share) {
            setShowChatShare(true);
          }

          if (botResponse.show_sign_up) {
            setTimeout(() => {
              // Add a small delay to sign up modal
              setShowSignUpModal(true);
            }, 500);
          }

          if (botResponse.show_paywall) {
            // setShowPaywallAfter(true)
            setTimeout(() => {
              // Add a small delay to sign up modal
              setShowPaywallModal(true);
            }, 500);
          }

          if (botResponse.show_past_due_modal) {
            // setShowPaywallAfter(true)
            setTimeout(() => {
              // Add a small delay to sign up modal
              setShowPastDueModal(true);
            }, 500);
          }

          questions_prepopulated = [message.message]; // Show the same question again...
          questions_prepop_tickers = [""];
        } else if (!botResponse || !botResponse.botMessage) {
          response_message = {
            createdAt: null,
            message: "Please try again, there was an unexpected server error.",
            sender: "bot",
            tickerDescription: [],
            answeredTickerIds: [],
            logoUrls: [],
          };
          questions_prepopulated = [message.message]; //Show the same question again...
          questions_prepop_tickers = [""];
        } else {
          console.log(
            "should be in the else",
            botResponse.botMessage,
            botResponse.questionsPrepop,
            botResponse.questionsPrepopTickers,
          );
          response_message = botResponse.botMessage;
          questions_prepopulated = botResponse.questionsPrepop;
          questions_prepop_tickers = botResponse.questionsPrepopTickers;
        }

        if (botResponse?.skipBotMessage) {
          if (resolvedThreadUuid) {
            setThreadLoadingResponse(resolvedThreadUuid, false);
            setThreadShowLoadingWaitingMessage(resolvedThreadUuid, 0);
            setThreadLoadingPhaseMessage(resolvedThreadUuid, null);
            setThreadLoadingPhaseDetail(resolvedThreadUuid, null);
            setThreadLiveTextOutputting(resolvedThreadUuid, false);
          } else {
            setLoadingResponse(false);
            setShowLoadingWaitingMessage(0);
          }
          setOpacity(0.0);
          setOpacity(1.0);
          setButtonOpacity(0.999);
          if (resolvedThreadUuid) {
            setThreadPreventQuestionInput(resolvedThreadUuid, false);
          } else {
            setPreventQuestionInput(false);
          }
          return;
        }

        if (botResponse?.shouldShowReview) {
          setTimeout(() => {
            setShowReviewModal(true);
          }, 500);
        }
        setUserData({
          ...userData,
          ...{
            show_user_profession: botResponse.showUserProfession,
            user_profession: botResponse.userProfession,
            showAskShareMessage: botResponse.showAskShareMessage,
          },
        });

        if (botResponse.showSaveHomePopup && isMobileIOS()) {
          setShowAddHomeModal(true);
        }

        if (botResponse.showSubscriptionOffer) {
          setTimeout(() => {
            // Add a small delay to sign up modal
            setShowSubOfferModal("offering");
          }, 500);
        }
        setFreeUnlimitedOnly(botResponse.freeUnlimitedOnly);
        setHasShownFreeUnlimitedMessage(
          botResponse.hasShownFreeUnlimitedMessage,
        );

        if (!isLoggedIn && userData.requireSignIn) {
          if (userData.uuidHasAccount) {
            appProps.setRegisterNavMessage(requireLoginMessage);
          } else {
            appProps.setRegisterNavMessage(requireCreateAccountMessage);
          }
          // setShowSignInButtons(true) // This will show the buttons to sign in/up
          navigate("/register");
        }

        // upon response, wait 3 seconds then show response
        let timeout = 50;
        setTimeout(() => {
          if (resolvedThreadUuid) {
            setThreadThing(resolvedThreadUuid, true);
            setThreadTestResponseMessage(resolvedThreadUuid, response_message);
            setThreadLoadingResponse(resolvedThreadUuid, false);
            setThreadShowLoadingWaitingMessage(resolvedThreadUuid, 0);
            setThreadLoadingPhaseMessage(resolvedThreadUuid, null);
            setThreadLoadingPhaseDetail(resolvedThreadUuid, null);
            setThreadLiveTextOutputting(resolvedThreadUuid, false);
          } else {
            checkThing(true);
            setTestResponseMessage(response_message);
            setLoadingResponse(false);
            setShowLoadingWaitingMessage(0);
          }
          setOpacity(0.0);
          setOpacity(1.0);
          setButtonOpacity(0.999); //So weird.. if I set this back to 1.0 it won't work!!!
        }, timeout);
        // show the question answers:

        // Have shown the answer, now show the heart & share:
        timeout = timeout;
        setTimeout(() => {
          if (resolvedThreadUuid) {
            setResponseFlowForThread(resolvedThreadUuid, (responseFlow) => ({
              ...responseFlow,
              review: true,
            }));
          } else {
            setResponseFlow((responseFlow) => ({
              ...responseFlow,
              review: true,
            }));
          }
        }, timeout);

        // Show the Show "Ask Next"
        timeout = timeout + 200;
        setTimeout(() => {
          if (resolvedThreadUuid) {
            setResponseFlowForThread(resolvedThreadUuid, (responseFlow) => ({
              ...responseFlow,
              text: true,
            }));
          } else {
            setResponseFlow((responseFlow) => ({
              ...responseFlow,
              text: true,
            }));
          }
        }, timeout);

        timeout = timeout + 200;
        questions_prepopulated.forEach((message_text, idx) => {
          let q = {
            sender: "human",
            isButton: true,
            message: message_text,
          };
          setTimeout(() => {
            if (idx == 0) {
              if (resolvedThreadUuid) {
                setResponseFlowForThread(
                  resolvedThreadUuid,
                  (responseFlow) => ({
                    ...responseFlow,
                    question1: [true, q.message, null, false, null],
                  }),
                );
              } else {
                setResponseFlow((responseFlow) => ({
                  ...responseFlow,
                  question1: [true, q.message, null, false, null],
                }));
              }
            } else {
              if (resolvedThreadUuid) {
                setResponseFlowForThread(
                  resolvedThreadUuid,
                  (responseFlow) => ({
                    ...responseFlow,
                    question2: [
                      true,
                      q.message,
                      null,
                      botResponse.isAdvanced,
                      botResponse.advancedType,
                    ],
                  }),
                );
              } else {
                setResponseFlow((responseFlow) => ({
                  ...responseFlow,
                  question2: [
                    true,
                    q.message,
                    null,
                    botResponse.isAdvanced,
                    botResponse.advancedType,
                  ],
                }));
              }
            }

            if (botResponse.showSignUp) {
              setTimeout(() => {
                setShowSignUpModal(true);
              }, 500);
            }
          }, timeout);
        });

        // Show the Show Regenerateive button
        timeout = timeout + 200;
        setTimeout(() => {
          if (resolvedThreadUuid) {
            setResponseFlowForThread(resolvedThreadUuid, (responseFlow) => ({
              ...responseFlow,
              regen: true,
            }));
            // ALLOW AGAIN!!!
            setThreadPreventQuestionInput(resolvedThreadUuid, false);
          } else {
            setResponseFlow((responseFlow) => ({
              ...responseFlow,
              regen: true,
            }));
            // ALLOW AGAIN!!!
            setPreventQuestionInput(false);
          }
        }, timeout);
        // Now after the final timeout, show the ask next etc. etc.
      })
      .catch((error) => {
        hasReceivedResponse = true;
        console.error("sendChatMessages failed", error);

        const response_message = {
          createdAt: null,
          message: "Please try again, there was an unexpected server error.",
          sender: "bot",
          tickerDescription: [],
          answeredTickerIds: [],
          logoUrls: [],
        };

        if (threadUuid) {
          setThreadThing(threadUuid, true);
          setThreadTestResponseMessage(threadUuid, response_message);
          setThreadLoadingResponse(threadUuid, false);
          setThreadShowLoadingWaitingMessage(threadUuid, 0);
          setThreadLoadingPhaseMessage(threadUuid, null);
          setThreadLoadingPhaseDetail(threadUuid, null);
          setThreadLiveTextOutputting(threadUuid, false);
          setThreadPreventQuestionInput(threadUuid, false);

          setResponseFlowForThread(threadUuid, (responseFlow) => ({
            ...responseFlow,
            question1: [true, message.message, null, false, null],
            question2: [false, responseFlow.question2[1]],
            regen: true,
          }));
        } else {
          checkThing(true);
          setTestResponseMessage(response_message);
          setLoadingResponse(false);
          setShowLoadingWaitingMessage(0);
          setPreventQuestionInput(false);

          setResponseFlow((responseFlow) => ({
            ...responseFlow,
            question1: [true, message.message, null, false, null],
            question2: [false, responseFlow.question2[1]],
            regen: true,
          }));
        }

        setOpacity(0.0);
        setOpacity(1.0);
        setButtonOpacity(0.999);
      })
      .finally(() => {
        const current = inFlightSendByThreadRef.current?.[requestKey];
        if (current?.requestToken !== requestToken) return;
        delete inFlightSendByThreadRef.current[requestKey];
      });
  };

  // This does the check for free unlimited only on load.
  useEffect(() => {
    if (messageThreads.length > 1) {
      // Check for regular user:
      if (
        userData.user_account_info &&
        userData.user_account_info.free_unlimited_only
      ) {
        setFreeUnlimitedOnly(userData.user_account_info.free_unlimited_only);
      }
      // Check for a pre account user (will not be within user_account_info object since that is not preset for pre account user.)
      else if (userData && userData.free_unlimited_only) {
        setFreeUnlimitedOnly(userData.free_unlimited_only);
      }
    }
  }, [userData.user_account_info, messageThreads && messageThreads.length]);

  useEffect(() => {
    if (isLoggedIn && userData?.user_account_info && !userData.user_account_info.onboarding_modal_dismissed) {
      setAboutUserModal(true);
    }
    const threadUuid = activeThread?.threadUuid ?? null;
    if (!threadUuid) return;
    if (!loadingResponseByThreadUuid?.[threadUuid]) {
      setThreadLoadingPhaseMessage(threadUuid, null); // reset loading phase for this thread
      setThreadLoadingPhaseDetail(threadUuid, null);
      setThreadLiveTextOutputting(threadUuid, false); // reset live text for this thread
    }
  }, [
    isLoggedIn,
    userData,
    activeThread?.threadUuid,
    loadingResponseByThreadUuid,
    setThreadLoadingPhaseMessage,
    setThreadLoadingPhaseDetail,
    setThreadLiveTextOutputting,
  ]);

  const handleAddThread = () => {
    // Invalidate any in-flight selectActiveThread fetch so stale responses are ignored.
    threadSelectionTokenRef.current = threadSelectionTokenRef.current + 1;
    const hasUserEnteredMessage = (threadUuid) => {
      const threadMessages = messagesByThreadUuidRef.current?.[threadUuid];
      if (!Array.isArray(threadMessages) || threadMessages.length === 0) {
        return false;
      }
      return threadMessages.some((message) => {
        if (!message || message.sender !== "human") return false;
        const text =
          typeof message.message === "string" ? message.message.trim() : "";
        const hasAttachments =
          Array.isArray(message.attachments) && message.attachments.length > 0;
        return text.length > 0 || hasAttachments;
      });
    };
    const isEmptyTempThread = (thread) => {
      const threadUuid = thread?.threadUuid;
      if (!threadUuid?.startsWith("temp-")) return false;
      return !hasUserEnteredMessage(threadUuid);
    };
    const reusableTempThread = isEmptyTempThread(activeThread)
      ? activeThread
      : Array.isArray(threads)
        ? threads.find((thread) => isEmptyTempThread(thread))
        : null;

    if (reusableTempThread) {
      selectActiveThread(reusableTempThread);
      if (isMobile) {
        setIsSidebarOpen(false);
      }
      return;
    }

    const existingTempCount = Array.isArray(threads)
      ? threads.filter((thread) => thread?.threadUuid?.startsWith("temp-"))
          .length
      : 0;
    const tempTitle =
      existingTempCount > 0
        ? `New Thread ${existingTempCount + 1}`
        : "New Thread";

    const newThread = {
      threadUuid: `temp-${uuid()}`,
      title: tempTitle,
      isAdminTargeted: false,
    };
    setThreads((prev) => [newThread, ...(Array.isArray(prev) ? prev : [])]);
    setActiveThread(newThread);
    activeThreadRef.current = newThread;
    messageThreadsOwnerRef.current = newThread.threadUuid;
    setMessageThreads([]);
    setLoadingMessages(false);
    ensureResponseFlowForThread(newThread.threadUuid);

    if (isMobile) {
      // on mobile, automatically close the side panel
      setIsSidebarOpen(false);
    }
  };

  useEffect(() => {
    if (!shouldForceFreshLoadThreadRef.current) return;
    if (hasForcedFreshLoadThreadRef.current) return;
    if (loadingUserData) return;
    if (userData?.user_id) {
      hasForcedFreshLoadThreadRef.current = true;
      return;
    }
    handleAddThread();
    hasForcedFreshLoadThreadRef.current = true;
  }, [loadingUserData, userData?.user_id, handleAddThread]);

  const GOOGLE_REVIEW_URL =
    "https://www.google.com/search?q=incite+ai&rlz=1C5ZNUK_enUS1142US1143&oq=Incite+ai&gs_lcrp=EgZjaHJvbWUqCggAEAAY4wIYgAQyCggAEAAY4wIYgAQyEAgBEC4YrwEYxwEYgAQYjgUyBwgCEAAYgAQyBwgDEAAYgAQyBwgEEAAYgAQyBwgFEAAYgAQyBggGEEUYPDIGCAcQRRg80gEHOTIyajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x80c2bf0722b08d53:0x7ccdb9808ae36d74,3,,,,";

  const handleCloseReviewModal = async () => {
    try {
      await updateUserReview(false);
    } catch (e) {
    } finally {
      setShowReviewModal(false);
      setIsGoogleReview(false);
    }
  };

  const handleRating = (rate) => {
    setRating(rate);
  };

  const handleReviewSubmit = async () => {
    try {
      if (isGoogleReview) {
        if (typeof window !== "undefined") {
          window.open(GOOGLE_REVIEW_URL, "_blank", "noopener,noreferrer");
        }
        setShowReviewModal(false);
        setIsGoogleReview(false);
        return;
      }

      if (rating > 0 && rating <= 5) {
        await updateUserReview(true, rating);
      }

      if (rating === 5) {
        setIsGoogleReview(true);
      } else {
        setShowReviewModal(false);
      }
    } catch (err) {
      console.error("Failed to submit review", err);
      setIsGoogleReview(false);
      setShowReviewModal(false);
    }
  };

  // This ensures that even if we delete a thrad, that we create a new one!
  useEffect(() => {
    if (
      loadingMessageThreads ||
      loadingUserData ||
      Object.keys(userData).length == 0
    )
      return;
    const isPreAccount = !userData.user_id && !userData.user_account_info;
    if ((threads && threads.length == 0) || (!threads && isPreAccount)) {
      handleAddThread();
    }
  }, [threads, userData, loadingUserData, loadingMessageThreads]);

  return (
    <Sidebar
      selectActiveThread={selectActiveThread}
      hasAccount={userData.uuidHasAccount}
      isSidebarOpen={isSidebarOpen}
      setIsSidebarOpen={setIsSidebarOpen}
      handleAddThread={handleAddThread}
      onQuestionSubmit={sendUserQuestion}
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          backgroundColor: "#FAFAFA",
        }}
      >
        {/* CHAT BOX */}
        <Box sx={{ width: "100%" }}>
          {showTermsModal && (
            <TermsModal
              showTermsModal={showTermsModal}
              setShowTermsModal={setShowTermsModal}
              setHasAcceptedTerms={setHasAcceptedTerms}
            />
          )}
          {showAddHomeModal && (
            <AddAppHomeModal
              showAddHomeModal={showAddHomeModal}
              setShowAddHomeModal={setShowAddHomeModal}
            />
          )}
          {showSignUpModal && (
            <SignUpModalV2
              userData={userData}
              setUserData={setUserData}
              setShowSignUpModal={setShowSignUpModal}
              showPaywallAfter={showPaywallAfter}
              setShowPaywallModal={setShowPaywallModal}
              isSidebarOpen={isSidebarOpen}
              sidebarOffset={sidebarOffset}
            />
          )}
          {showPaywallModal && (
            <PaywallModal
              appProps={appProps}
              userData={userData}
              setUserData={setUserData}
              setShowPaywallModal={setShowPaywallModal}
              paywallMessage={paywallMessage}
              setShowSignUpModal={setShowSignUpModal}
              setShowPaywallAfter={setShowPaywallAfter}
              isSidebarOpen={isSidebarOpen}
              sidebarOffset={sidebarOffset}
            />
          )}
          {showPastDueModal && (
            <PastDueModal
              userData={userData}
              setUserData={setUserData}
              setShowPastDueModal={setShowPastDueModal}
              paywallMessage={paywallMessage}
              setShowSignUpModal={setShowSignUpModal}
              setShowPaywallAfter={setShowPaywallAfter}
              isSidebarOpen={isSidebarOpen}
            />
          )}
          {aboutUserModal && (
            <AboutUserModal
              aboutUserModal={aboutUserModal}
              setAboutUserModal={setAboutUserModal}
              userData={userData}
              setUserData={setUserData}
            />
          )}

          {showSubOfferModal == "offering" && (
            <SubscriptionOfferCoupon
              setShowSubOfferModal={setShowSubOfferModal}
            />
          )}

          <ChatBox
            isDesktop={isDesktop}
            anchorOffsetTop={anchorOffsetTop}
            sidebarOffset={sidebarOffset}
            messageThreads={messageThreads}
            isSidebarOpen={isSidebarOpen}
            setQuestion={setQuestion}
            onQuestionSubmit={sendUserQuestion}
            onBeginEditMessage={handleBeginEditMessage}
            loadingResponse={loadingResponse}
            userData={userData}
            setUserData={setUserData}
            chatRef={chatRef}
            chatContainerRef={chatContainerRef}
            chatMessagesContainerRef={chatMessagesContainerRef}
            hasShownHistory={hasShownHistory}
            regenButtonRecommendations={regenButtonRecommendations}
            preventQuestionInput={preventQuestionInput}
            setPreventQuestionInput={setPreventQuestionInput}
            showLoadingWaitingMessage={showLoadingWaitingMessage}
            setShowLoadingWaitingMessage={setShowLoadingWaitingMessage}
            useFullWidth={useFullWidth}
            isSecondaryExperience={isSecondaryExperience}
            isNewUUID={isNewUUID}
            loadingUserData={loadingUserData}
            setIsSecondaryExperience={setIsSecondaryExperience}
            showSignInButtons={showSignInButtons}
            setQuestionOnDemand={setQuestionOnDemand}
            editingMessage={editingMessage}
          />
        </Box>

        <ReviewModal
          open={showReviewModal}
          onClose={handleCloseReviewModal}
          onSubmit={handleReviewSubmit}
          onRating={handleRating}
          rating={rating}
          isGoogle={isGoogleReview}
        />
        {/* NAVBAR */}
        <ProBanner
          userData={userData}
          isLoggedIn={isLoggedIn}
          loadingUserData={loadingUserData}
          isSidebarOpen={isSidebarOpen}
          isDataProcessesOpen={isDataProcessesOpen}
          messageThreads={messageThreads}
        />
        <Box
          sx={{ position: "fixed", left: "0px", top: "0px", width: "100%" }}
          ref={navRef}
        >
          {!loadingUserData && (
            <Navbar
              isSidebarOpen={isSidebarOpen}
              isDataProcessesOpen={isDataProcessesOpen}
              setIsSidebarOpen={setIsSidebarOpen}
              appProps={appProps}
              allowAbout={true}
              showSubscriptionStatus={true}
              onQuestionSubmit={sendUserQuestion}
            />
          )}
        </Box>
        <Box sx={{ width: "100%", marginBottom: "10px" }}>
          <Input
            userData={userData}
            sidebarOffset={sidebarOffset}
            isDesktop={isDesktop}
            showSignInButtons={showSignInButtons}
            onFocus={onFocus}
            onBlur={onBlur}
            question={question}
            setQuestion={setQuestion}
            onQuestionSubmit={handleInputSubmit}
            placeholderText={placeholderText}
            preventQuestionInput={preventQuestionInput}
            inputPlaceholderText={inputPlaceholderText}
            activeThread={activeThread}
            editingMessage={editingMessage}
            onCancelEdit={handleCancelEdit}
            cancelRequested={cancelRequested}
            handleAbortResponse={handleAbortResponse}
            loadingResponse={loadingResponse}
            loadingMessages={loadingMessages}
            loadingUserData={loadingUserData}
            loadingUserMessages={loadingUserMessages}
            messageThreads={messageThreads}
          />
          {/* <PrechatVersion/> */}
        </Box>
      </Box>
      <DataOutput loadingResponse={loadingResponse} />
    </Sidebar>
  );
};

export default ChatPage;
